import { priceLineConstants } from "../constants/priceLine.constants";
export function priceLine(state = [{ searchBy: "Part Number" }], action) {
  if (action && action.type) {
    switch (action.type) {
      // Quotes
      case priceLineConstants.PRICELINE_ORDERS_REQUEST:
        return { retrievingPBH: true };
      case "PRICELINE_ORDERS_SEARCHBY":
        console.log("reducer trig");
        return { searchBy: action.searchBy };
      case priceLineConstants.PRICELINE_ORDERS_SUCCESS:
        return {
          orders: action.orders,
          batch: state.batch,
          newUpload: state.newUpload,
        };

      case priceLineConstants.PRICELINE_ORDERS_FAILURE:
        return {};

      // Quotes Details
      case priceLineConstants.PRICELINE_ORDER_DETAILS_REQUEST:
        return { retrievingPBHD: true };
      case priceLineConstants.PRICELINE_ORDER_DETAILS_SUCCESS:
        return { order: action.orders };
      case priceLineConstants.PRICELINE_ORDER_DETAILS_FAILURE:
        return {};

      // Quotes Search Query
      case priceLineConstants.PRICELINE_ORDERS_SEARCH_REQUEST:
        return { searchingPBH: true };
      case priceLineConstants.PRICELINE_ORDERS_SEARCH_SUCCESS:
        return { orders: action.orders };
      case priceLineConstants.PRICELINE_ORDERS_SEARCH_FAILURE:
        return {};

      case "SET_BATCH":
        return {
          orders: state.orders,
          batch: action.batch,
          newUpload: state.newUpload,
        };
      case "NEW_UPLOAD":
        return {
          orders: state.orders,
          batch: state.batch,
          newUpload: action.newUpload,
        };

      default:
        return state;
    }
  }
}
